export { NoFlickerImage as default } from 'react-native-no-flicker-image';
